function required(name: string, value: string | undefined): string {
  const v = (value ?? '').trim();
  if (!v) {
    throw new Error(
      `Fehlende Umgebungsvariable ${name}. Bitte in .env setzen (siehe .env.example).`,
    );
  }
  return v;
}

export const config = {
  clientId: required('VITE_CLIENT_ID', import.meta.env.VITE_CLIENT_ID),
  tenantId: required('VITE_TENANT_ID', import.meta.env.VITE_TENANT_ID),
  appUrl: (import.meta.env.VITE_APP_URL || 'https://signatur.sundos.de').replace(/\/$/, ''),
  graphBase: 'https://graph.microsoft.com/v1.0',
  signatureFolderName: 'SignatureApp',
  signatureFileName: 'signature.png',
  /** Max PNG upload size (bytes). */
  maxSignatureBytes: 5 * 1024 * 1024,
  /** Graph scopes needed for /me + OneDrive folder create */
  graphScopes: ['User.Read', 'Files.ReadWrite'] as string[],
  get authority() {
    return `https://login.microsoftonline.com/${this.tenantId}`;
  },
  get isDev() {
    return import.meta.env.DEV;
  },
};
